import apiWhatsAppList from '@/views/pages/komship/customer/Broadcast/service/api.whatsAppList.service'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import { apiGetSubsPlan } from '@/views/pages/komship/opsional/service/api.whatsapp.services'
import { apiListWareHousess } from '@/views/pages/komship/customer/Ai/service/api.warehouse.service'
import { apiGetProuctList } from '@/views/pages/komship/customer/Ai/service/api.product.service'
import { apiGetPaymentInterface } from '@/views/pages/komship/customer/Ai/service/api.paymentInterface.service'

export default {
  namespaced: true,
  state: {
    whatsAppList: [],
    subsPlanList: [],
    warehouseList: [],
    productList: [],
    paymentInterface: [],
    formData: {
      store_name: 'Indah',
      customer_service_name: '',
      customer_service_gender: '',
      language_style: '',
      greeting: '',
      job_description: 'Beri Salam "Pagi, Siang, Sore / Malam" harus mengikuti Zona Waktu mengikuti Asia/Jakarta +7 Jangan ada pengulangan pengenalan nama / sapaan! Panduan Objection Handling yang Wajib Diikuti: 1. Menanyakan Lokasi  Saat calon pembeli pertama kali masuk, sambut dengan sapaan ramah dan tanyakan asal mereka: “Halo kak, dengan kak siapa dimana?” 2. Menawarkan Produk dan Harga Setelah mengetahui nama dan lokasi, informasikan produk yang tersedia beserta harganya. Jelaskan secara singkat fitur dan manfaat produk, lalu tanyakan: “Apakah sudah cocok, Kak? atau ada yang ingin ditanyakan lagi?” 3. Menanyakan Paket atau Ukuran Setelah menyampaikan harga, tanyakan paket atau ukuran yang diinginkan jika tersedia pada deskripsi produk. Berikan rekomendasi paket sesuai kebutuhan. 4. Menghitung Ongkir dan Menawarkan Metode Pembayaran  Jika pembeli setuju, minta alamat pengiriman lengkap (Kota/Kabupaten, Provinsi). Jelaskan metode pembayaran: - COD (Bayar di Tempat): Tambahkan biaya 3% dari total harga dan ongkir, tetapi tidak perlu menyebutkan secara eksplisit. - Transfer Bank: Beri tahu bahwa metode transfer mendapat diskon 3%. Hitung ongkir berdasarkan berat total produk yang dibeli. 5. Meminta Alamat dan Menjelaskan Sistem COD Jika memilih COD, minta alamat lengkap dengan format berikut: - Nama  - Nomor HP  - Nomor Rumah (jika ada) - Jalan/Gang  - Dusun (jika ada) - Desa - Kecamatan - Kota/Kabupaten - Provinsi - Patokan rumah (jika ada) atau minta ShareLoc. Jelaskan bahwa paket tidak bisa dibuka sebelum pembayaran selesai. 6. Mengkonfirmasi Pesanan  Setelah alamat diberikan, konfirmasi ulang detail pesanan untuk memastikan tidak ada perubahan. Akhiri percakapan dengan menginformasikan bahwa pesanan segera diproses dan dikirimkan.',
    },
  },
  mutations: {
    SET_FORM_DATA(state, payload) {
      state.formData = {
        ...state.formData,
        ...payload,
      }
    },
    UPDATE_WHATSAPP_LIST(state, value) {
      state.whatsAppList = value
    },
    UPDATE_SUBSPLAN_LIST(state, value) {
      state.subsPlanList = value
    },
    UPDATE_WAREHOUSE_LIST(state, value) {
      state.warehouseList = value
    },
    UPDATEPRODUCT_LIST(state, value) {
      state.productList = value
    },
    UPDATE_PAYMENT_INTERFACE(state, value) {
      state.paymentInterface = value
    },
  },
  actions: {
    updateFormData({ commit }, payload) {
      commit('SET_FORM_DATA', payload)
    },
    async getWhatsAppList({ commit }) {
      try {
        const { data } = await apiWhatsAppList()
        const listKomchat = data.data.filter(item => item.type !== 'wap')
        commit('UPDATE_WHATSAPP_LIST', listKomchat)
      } catch (error) {
        console.error(error)
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: 'Failed',
            text: error.response.data.error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async getSubsPlanList({ commit }) {
      try {
        const { data } = await apiGetSubsPlan()
        const listPlanActivate = data.data
        commit('UPDATE_SUBSPLAN_LIST', listPlanActivate)
      } catch (error) {
        console.error(error)
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: 'Failed',
            text: error.response.data.error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async getWarehouseList({ commit }) {
      try {
        const { data } = await apiListWareHousess()
        const listWarehouse = data.data
        commit('UPDATE_WAREHOUSE_LIST', listWarehouse)
      } catch (error) {
        console.error(error)
        this.$toast_error({ message: error.response.data.error })
      }
    },
    async getProductList({ commit, state }, payload = {}) {
      try {
        const {
          keyword = '', page = 0, limit = 15, append = false,
        } = payload

        const { data } = await apiGetProuctList({ keyword, page: String(page), limit: String(limit) })
        const listProduct = data.data || []

        if (append) {
          // Append new products to existing list
          const existingIds = new Set(state.productList.map(p => p.id))
          const newProducts = listProduct.filter(p => !existingIds.has(p.id))
          commit('UPDATEPRODUCT_LIST', [...state.productList, ...newProducts])
        } else {
          // Replace product list
          commit('UPDATEPRODUCT_LIST', listProduct)
        }

        return { count: listProduct.length, total: state.productList.length }
      } catch (error) {
        console.error('Error loading products:', error)
        throw error
      }
    },
    async getPaymentInterface({ commit }) {
      try {
        const { data } = await apiGetPaymentInterface()
        const listPaymentInterface = data.data
        commit('UPDATE_PAYMENT_INTERFACE', listPaymentInterface)
      } catch (error) {
        this.$toast_error({ message: error.response?.data?.error || 'Gagal memuat produk' })
      }
    },
  },
  getters: {
    getFormData: state => state.formData,
  },
}
